import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5bf2b8d2"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bf2b8d2')) {
      api.createRecord('5bf2b8d2', component.options)
    } else {
      api.reload('5bf2b8d2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5bf2b8d2", function () {
      api.rerender('5bf2b8d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistics/cost/index.vue"
export default component.exports